import axios from 'axios'

const accessToken = localStorage.getItem('accessToken');
const base = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + accessToken
  }
});

const Api = {
  getDigitalCard(cardSlug) {
    return base.get(cardSlug);
  },
  getAgenda(agendaId, agendaData = {}) {
    return base.get(agendaId, { params: agendaData});
  },
  getAvailableHealthPlans(agendaId, appointmentData = {}) {
    return base.get('health-plans/' + agendaId, { params: appointmentData});
  },
  makeAppointment(agendaId, appointmentData) {
    return base.post(agendaId, appointmentData);
  },
};

export default Api
